import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import CreateDreamPage from './pages/CreateDreamPage';
import DreamMapPage from './pages/DreamMapPage';
import SearchPage from './pages/SearchPage';

const AppRoutes: React.FC = () => {
  const { user, loading, initialized } = useAuth();
  const location = useLocation();

  console.log('AppRoutes - State:', { 
    hasUser: !!user, 
    loading, 
    initialized,
    pathname: location.pathname,
    state: location.state,
    key: location.key
  });

  // Show loading spinner while Firebase is initializing
  if (!initialized) {
    console.log('AppRoutes - Waiting for initialization');
    return (
      <div className="flex items-center justify-center h-[calc(100vh-4rem)]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-dream-400"></div>
      </div>
    );
  }

  // While loading, preserve the current route/component
  if (loading) {
    console.log('AppRoutes - Loading, preserving current route');
    return (
      <Routes>
        <Route path="*" element={
          <div className="flex items-center justify-center h-[calc(100vh-4rem)]">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-dream-400"></div>
          </div>
        } />
      </Routes>
    );
  }

  console.log('AppRoutes - Rendering routes:', {
    isAuthenticated: !!user,
    currentPath: location.pathname
  });

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/profile/:userId" element={<ProfilePage />} />
      <Route path="/dreams/map/:userId?" element={<DreamMapPage />} />
      <Route path="/search" element={<SearchPage />} />

      {/* Protected routes - Redirect to login if not authenticated */}
      <Route
        path="/create"
        element={
          user ? (
            <CreateDreamPage />
          ) : (
            <Navigate to="/login" state={{ from: location }} replace />
          )
        }
      />

      <Route
        path="/profile"
        element={
          user ? (
            <Navigate to={`/profile/${user.uid}`} replace />
          ) : (
            <Navigate to="/login" state={{ from: location }} replace />
          )
        }
      />

      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes; 